<template>
  <section id="contact" class="resume-section">
    <div class="resume-section-content">
      <h2 class="mb-5">{{ contact }}</h2>
      <form @submit.prevent="sendEmail" class="row g-3">
        <div class="col-md-6">
          <label for="name" class="form-label">{{ nameLabel }}</label>
          <input type="text" id="name" v-model="formData.name" class="form-control" required />
        </div>
        <div class="col-md-6">
          <label for="email" class="form-label">{{ emailLabel }}</label>
          <input type="email" id="email" v-model="formData.email" class="form-control" required />
        </div>
        <div class="col-12">
          <label for="message" class="form-label">{{ messageLabel }}</label>
          <textarea id="message" v-model="formData.message" class="form-control" required></textarea>
        </div>
        <div class="col-12">
          <button type="submit" class="btn btn-primary">{{ sendLabel }}</button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        name: '',
        email: '',
        message: '',
      },
    };
  },
  computed: {
    contact() {
      return this.$t('sections.contact');
    },
    nameLabel() {
      return this.$t('contact.name');
    },
    emailLabel() {
      return this.$t('contact.email');
    },
    messageLabel() {
      return this.$t('contact.message');
    },
    sendLabel() {
      return this.$t('contact.send');
    },
    email() {
      return this.$t('profile.email');
    },
    successMessage() {
      return this.$t('contact.success');
    },
    errorMessage() {
      return this.$t('contact.error');
    }
  },
  methods: {
    sendEmail() {
      const subject = `Contact from ${this.formData.name}`;
      const body = `Name: ${this.formData.name}\nEmail: ${this.formData.email}\n\nMessage:\n${this.formData.message}`;
      const mailtoLink = `mailto:${this.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      
      // Open default email client
      window.open(mailtoLink);
      
      // Clear form after sending
      this.formData = {
        name: '',
        email: '',
        message: '',
      };
      
      // Show success message
      alert(this.successMessage);
    },
  },
};
</script>
